(function () {
  function initProductPersonalization(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var form = root.closest('form');
    if (!form) return;

    var errorBox = root.querySelector('[data-error]');
    var nameInput = root.querySelector('#personalization-name');
    var numberInput = root.querySelector('#personalization-number');
    var playerPresetSelect = root.querySelector('[data-player-preset-select]');

    var toggleName = root.querySelector('[data-toggle-trigger="name"]');
    var toggleNumber = root.querySelector('[data-toggle-trigger="number"]');
    var togglePatch = root.querySelector('[data-toggle-trigger="patch"]');
    var toggleExtraPatch = root.querySelector('[data-toggle-trigger="extra-patch"]');
    var toggleMedias = root.querySelector('[data-toggle-trigger="medias"]');

    var panelName = root.querySelector('[data-toggle-panel="name"]');
    var panelNumber = root.querySelector('[data-toggle-panel="number"]');
    var panelPatch = root.querySelector('[data-toggle-panel="patch"]');
    var panelExtraPatch = root.querySelector('[data-toggle-panel="extra-patch"]');
    var panelMedias = root.querySelector('[data-toggle-panel="medias"]');

    var patchWrapper = root.querySelector('[data-patch-wrapper]');
    var patchHiddenInput = root.querySelector('[data-patch-hidden-input]');
    var patchOptions = Array.from(root.querySelectorAll('[data-patch-option]'));

    var extraPatchWrapper = root.querySelector('[data-extra-patch-wrapper]');
    var extraPatchHiddenInput = root.querySelector('[data-extra-patch-hidden-input]');
    var extraPatchOptions = Array.from(root.querySelectorAll('[data-extra-patch-option]'));
    var mediasHiddenInput = root.querySelector('[data-medias-hidden-input]');

    var fixedTriggers = Array.from(root.querySelectorAll('[data-fixed-trigger]'));

    function getI18n() {
      var node = root.querySelector('[data-product-personalization-i18n]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    var i18n = getI18n();
    function t(key, fallback) {
      return i18n[key] || fallback;
    }

    var MEDIAS_PRICE_CENTS = 600;
    var priceUpdateTimer = null;
    var isApplyingPersonalizedPrice = false;

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function hideAllFieldInfos() {
      root.querySelectorAll('[data-field-info]').forEach(function (box) {
        box.hidden = true;
        box.textContent = '';
      });
    }

    function showFieldInfo(target, message) {
      hideAllFieldInfos();
      if (!target) return;
      var box = root.querySelector('[data-field-info="' + target + '"]');
      if (!box) return;

      box.textContent = message;
      box.hidden = false;

      clearTimeout(box._hideTimer);
      box._hideTimer = setTimeout(function () {
        box.hidden = true;
        box.textContent = '';
      }, 2500);
    }

    function markInvalid(el) {
      if (!el) return;
      el.classList.add('product-personalization__input--invalid');
    }

    function unmarkInvalid(el) {
      if (!el) return;
      el.classList.remove('product-personalization__input--invalid');
    }

    function markPatchInvalid() {
      if (!patchWrapper) return;
      patchWrapper.classList.add('product-personalization__patches--invalid');
    }

    function unmarkPatchInvalid() {
      if (!patchWrapper) return;
      patchWrapper.classList.remove('product-personalization__patches--invalid');
    }

    function markExtraPatchInvalid() {
      if (!extraPatchWrapper) return;
      extraPatchWrapper.classList.add('product-personalization__patches--invalid');
    }

    function unmarkExtraPatchInvalid() {
      if (!extraPatchWrapper) return;
      extraPatchWrapper.classList.remove('product-personalization__patches--invalid');
    }

    function resetPatchSelection() {
      if (patchHiddenInput) {
        patchHiddenInput.value = '';
        patchHiddenInput.disabled = true;
      }

      patchOptions.forEach(function (option) {
        option.classList.remove('is-selected');
        option.setAttribute('aria-pressed', 'false');
      });

      unmarkPatchInvalid();
    }

    function resetExtraPatchSelection() {
      if (extraPatchHiddenInput) {
        extraPatchHiddenInput.value = '';
        extraPatchHiddenInput.disabled = true;
      }

      extraPatchOptions.forEach(function (option) {
        option.classList.remove('is-selected');
        option.setAttribute('aria-pressed', 'false');
      });

      unmarkExtraPatchInvalid();
    }

    function getAddToCartButtons() {
      return Array.from(
        form.querySelectorAll('button[type="submit"], [name="add"], .product-form__submit')
      ).filter(function (button) {
        return !button.closest('.shopify-payment-button');
      });
    }

    function getDynamicCheckoutWrappers() {
      var selectors = [
        '.shopify-payment-button',
        '.shopify-payment-button__button',
        '[data-shopify="payment-button"]',
        '.product-form__buttons .additional-checkout-buttons'
      ];

      var found = [];
      selectors.forEach(function (selector) {
        form.querySelectorAll(selector).forEach(function (el) {
          if (found.indexOf(el) === -1) found.push(el);
        });
      });

      return found;
    }

    function isAnyToggleOpen() {
      return !!(
        (toggleName && toggleName.classList.contains('is-on')) ||
        (toggleNumber && toggleNumber.classList.contains('is-on')) ||
        (togglePatch && togglePatch.classList.contains('is-on')) ||
        (toggleExtraPatch && toggleExtraPatch.classList.contains('is-on')) ||
        (toggleMedias && toggleMedias.classList.contains('is-on'))
      );
    }

    function updateDynamicCheckoutVisibility() {
      var shouldHide = isAnyToggleOpen();
      var wrappers = getDynamicCheckoutWrappers();

      wrappers.forEach(function (el) {
        el.hidden = shouldHide;
        el.style.display = shouldHide ? 'none' : '';
        el.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      });
    }

    function isPersonalizationReady() {
      var nameIsOpen = toggleName && toggleName.classList.contains('is-on');
      var numberIsOpen = toggleNumber && toggleNumber.classList.contains('is-on');
      var patchIsOpen = togglePatch && togglePatch.classList.contains('is-on');
      var extraPatchIsOpen = toggleExtraPatch && toggleExtraPatch.classList.contains('is-on');

      if (nameIsOpen && nameInput && !nameInput.value.trim()) return false;
      if (numberIsOpen && numberInput && !numberInput.value.trim()) return false;
      if (patchIsOpen && patchHiddenInput && !patchHiddenInput.value.trim()) return false;
      if (extraPatchIsOpen && extraPatchHiddenInput && !extraPatchHiddenInput.value.trim()) return false;

      return true;
    }

    function updateAddToCartState() {
      var buttons = getAddToCartButtons();
      var ready = isPersonalizationReady();

      buttons.forEach(function (button) {
        button.disabled = !ready;
        button.setAttribute('aria-disabled', ready ? 'false' : 'true');
        button.classList.toggle('is-disabled-by-personalization', !ready);
      });

      updateDynamicCheckoutVisibility();
    }

    function getProductScope() {
      return form.closest('.js-product') || form.closest('section') || document;
    }

    function getCurrentVariantData() {
      var scope = getProductScope();
      var script = scope.querySelector('variant-picker script[type="application/json"]');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return null;
      }
    }

    function getCurrencyCode() {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return Shopify.currency.active;
      }
      return 'EUR';
    }

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: getCurrencyCode()
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2).replace('.', ',') + ' €';
      }
    }

    function getPriceBlocks() {
      var scope = getProductScope();
      return Array.from(scope.querySelectorAll('.product-info__price .price, sticky-atc-panel .price')).filter(function (node, index, arr) {
        return arr.indexOf(node) === index;
      });
    }

    function updateDisplayedPrice() {
      var variant = getCurrentVariantData();
      if (!variant) return;

      var mediasOn = !!(toggleMedias && toggleMedias.classList.contains('is-on'));
      var delta = mediasOn ? MEDIAS_PRICE_CENTS : 0;
      var priceBlocks = getPriceBlocks();

      if (!priceBlocks.length) return;

      isApplyingPersonalizedPrice = true;

      priceBlocks.forEach(function (priceBlock) {
        var currentValue = priceBlock.querySelector('.price__current .js-value');
        var wasValue = priceBlock.querySelector('.price__was .js-value');

        if (currentValue) {
          currentValue.textContent = formatMoney(Number(variant.price || 0) + delta);
        }

        if (wasValue) {
          var compareAt = Number(variant.compare_at_price || 0);
          if (compareAt > Number(variant.price || 0)) {
            wasValue.textContent = formatMoney(compareAt + delta);
            priceBlock.classList.add('price--on-sale');
          } else {
            wasValue.textContent = '';
            priceBlock.classList.remove('price--on-sale');
          }
        }
      });

      setTimeout(function () {
        isApplyingPersonalizedPrice = false;
      }, 0);
    }

    function queuePriceUpdate() {
      clearTimeout(priceUpdateTimer);
      priceUpdateTimer = setTimeout(function () {
        updateDisplayedPrice();
      }, 20);
    }

    function setToggleState(trigger, panel, isOn, input) {
      if (!trigger || !panel) return;

      trigger.classList.toggle('is-on', isOn);
      trigger.classList.toggle('is-off', !isOn);
      trigger.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      panel.hidden = !isOn;

      if (input) {
        input.disabled = !isOn;
        if (!isOn) {
          input.value = '';
          unmarkInvalid(input);
        }
      }

      if (panel === panelPatch) {
        if (!isOn) {
          resetPatchSelection();
        }
      }

      if (panel === panelExtraPatch) {
        if (!isOn) {
          resetExtraPatchSelection();
        }
      }

      if (panel === panelMedias && mediasHiddenInput) {
        mediasHiddenInput.disabled = !isOn;
        mediasHiddenInput.value = isOn ? 'Si' : '';
        queuePriceUpdate();
      }
    }

    function togglePanel(trigger, panel, input) {
      var isCurrentlyOn = trigger.classList.contains('is-on');
      setToggleState(trigger, panel, !isCurrentlyOn, input);
      clearError();
      updateAddToCartState();
    }

    if (toggleName) {
      toggleName.addEventListener('click', function () {
        togglePanel(toggleName, panelName, nameInput);
      });
    }

    if (toggleNumber) {
      toggleNumber.addEventListener('click', function () {
        togglePanel(toggleNumber, panelNumber, numberInput);
      });
    }

    if (togglePatch) {
      togglePatch.addEventListener('click', function () {
        togglePanel(togglePatch, panelPatch, null);
      });
    }

    if (toggleExtraPatch) {
      toggleExtraPatch.addEventListener('click', function () {
        togglePanel(toggleExtraPatch, panelExtraPatch, null);
      });
    }

    if (toggleMedias) {
      toggleMedias.addEventListener('click', function () {
        togglePanel(toggleMedias, panelMedias, null);
      });
    }

    function normalizeNameValue(value) {
      return String(value || '')
        .normalize('NFC')
        .toUpperCase()
        .normalize('NFC')
        .replace(/[^\p{L}\p{M}\s.'’\-·]/gu, '')
        .replace(/\s+/g, ' ')
        .replace(/^\s+/, '');
    }

    function normalizeNumberValue(value) {
      var digits = String(value || '').replace(/[^0-9]/g, '');

      if (digits !== '') {
        var num = parseInt(digits, 10);
        if (num > 99) return '99';
      }

      return digits;
    }

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        this.value = normalizeNameValue(this.value);

        unmarkInvalid(this);
        clearError();
        updateAddToCartState();
      });
    }

    if (numberInput) {
      numberInput.addEventListener('input', function () {
        this.value = normalizeNumberValue(this.value);

        unmarkInvalid(this);
        clearError();
        updateAddToCartState();
      });
    }

    if (playerPresetSelect) {
      playerPresetSelect.addEventListener('change', function () {
        var selectedOption = this.options[this.selectedIndex];
        if (!selectedOption) return;

        var presetName = selectedOption.getAttribute('data-player-name') || '';
        var presetNumber = selectedOption.getAttribute('data-player-number') || '';

        if (!presetName && !presetNumber) return;

        if (presetName && toggleName && panelName && nameInput) {
          setToggleState(toggleName, panelName, true, nameInput);
          nameInput.value = normalizeNameValue(presetName);
          unmarkInvalid(nameInput);
        }

        if (presetNumber && toggleNumber && panelNumber && numberInput) {
          setToggleState(toggleNumber, panelNumber, true, numberInput);
          numberInput.value = normalizeNumberValue(presetNumber);
          unmarkInvalid(numberInput);
        }

        clearError();
        updateAddToCartState();
        queuePriceUpdate();
      });
    }

    if (patchOptions.length) {
      patchOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          var isSelected = this.classList.contains('is-selected');
          var patchValue = this.getAttribute('data-patch-value') || '';

          patchOptions.forEach(function (item) {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });

          if (isSelected) {
            if (patchHiddenInput) {
              patchHiddenInput.value = '';
              patchHiddenInput.disabled = true;
            }
          } else {
            this.classList.add('is-selected');
            this.setAttribute('aria-pressed', 'true');

            if (patchHiddenInput) {
              patchHiddenInput.value = patchValue;
              patchHiddenInput.disabled = !patchValue.trim();
            }
          }

          unmarkPatchInvalid();
          clearError();
          updateAddToCartState();
        });
      });
    }

    if (extraPatchOptions.length) {
      extraPatchOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          var isSelected = this.classList.contains('is-selected');
          var patchValue = this.getAttribute('data-extra-patch-value') || '';

          extraPatchOptions.forEach(function (item) {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });

          if (isSelected) {
            if (extraPatchHiddenInput) {
              extraPatchHiddenInput.value = '';
              extraPatchHiddenInput.disabled = true;
            }
          } else {
            this.classList.add('is-selected');
            this.setAttribute('aria-pressed', 'true');

            if (extraPatchHiddenInput) {
              extraPatchHiddenInput.value = patchValue;
              extraPatchHiddenInput.disabled = !patchValue.trim();
            }
          }

          unmarkExtraPatchInvalid();
          clearError();
          updateAddToCartState();
        });
      });
    }

    if (fixedTriggers.length) {
      fixedTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var target = this.getAttribute('data-fixed-target');
          var message = this.getAttribute('data-fixed-message') || t('fixedFallback', 'No es posible modificar este valor para este producto.');
          showFieldInfo(target, message);
        });
      });
    }

    function validatePersonalization(event) {
      clearError();
      hideAllFieldInfos();

      if (nameInput) unmarkInvalid(nameInput);
      if (numberInput) unmarkInvalid(numberInput);
      unmarkPatchInvalid();
      unmarkExtraPatchInvalid();

      var firstInvalidField = null;
      var nameIsOpen = toggleName && toggleName.classList.contains('is-on');
      var numberIsOpen = toggleNumber && toggleNumber.classList.contains('is-on');
      var patchIsOpen = togglePatch && togglePatch.classList.contains('is-on');
      var extraPatchIsOpen = toggleExtraPatch && toggleExtraPatch.classList.contains('is-on');

      if (nameIsOpen && nameInput) {
        var nameValue = nameInput.value.trim();
        if (!nameValue) {
          firstInvalidField = nameInput;
          showError(t('nameRequired', 'Introduce un nombre para continuar.'));
          markInvalid(nameInput);
        }
      }

      if (!firstInvalidField && numberIsOpen && numberInput) {
        var numberValue = numberInput.value.trim();
        if (!numberValue) {
          firstInvalidField = numberInput;
          showError(t('numberRequired', 'Introduce un numero para continuar.'));
          markInvalid(numberInput);
        }
      }

      if (!firstInvalidField && patchIsOpen && patchHiddenInput) {
        if (!patchHiddenInput.value.trim()) {
          firstInvalidField = patchWrapper;
          showError(t('patchRequired', 'Selecciona un parche para continuar.'));
          markPatchInvalid();
        }
      }

      if (!firstInvalidField && extraPatchIsOpen && extraPatchHiddenInput) {
        if (!extraPatchHiddenInput.value.trim()) {
          firstInvalidField = extraPatchWrapper;
          showError(t('extraPatchRequired', 'Selecciona un parche extra para continuar.'));
          markExtraPatchInvalid();
        }
      }

      if (firstInvalidField) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (typeof firstInvalidField.scrollIntoView === 'function') {
          firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return false;
      }

      return true;
    }

    function watchPriceChanges() {
      var scope = getProductScope();
      if (!scope) return;

      var observer = new MutationObserver(function () {
        if (isApplyingPersonalizedPrice) return;
        queuePriceUpdate();
      });

      observer.observe(scope, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    setToggleState(toggleName, panelName, false, nameInput);
    setToggleState(toggleNumber, panelNumber, false, numberInput);
    setToggleState(togglePatch, panelPatch, false, null);
    setToggleState(toggleExtraPatch, panelExtraPatch, false, null);
    setToggleState(toggleMedias, panelMedias, false, null);
    updateAddToCartState();
    queuePriceUpdate();
    watchPriceChanges();

    form.addEventListener('change', function () {
      queuePriceUpdate();
    });

    form.addEventListener('input', function () {
      queuePriceUpdate();
    });

    form.addEventListener('submit', validatePersonalization, true);
  }

  function initAllProductPersonalization(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-product-personalization]').forEach(function (root) {
      initProductPersonalization(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductPersonalization(document);
    });
  } else {
    initAllProductPersonalization(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductPersonalization(event.target);
  });
})();